import { testimonials } from "@/mocks/clueData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Testimonials() {
  return (
    <section className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
      <SectionHeading
        align="center"
        eyebrow="网友怎么说"
        icon="ri-chat-quote-line"
        title="投稿人与读者的真实反馈"
        desc="我们珍惜每一次信任。下面的话来自授权投稿人与长期读者，内容已做匿名处理。"
      />
      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6"
          >
            <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
            <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 border-t border-background-200 pt-4">
              <span className="block font-heading text-sm font-semibold text-foreground-950">
                {item.name}
              </span>
              <span className="mt-0.5 block text-xs text-foreground-500">{item.role}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}